import { Colors } from '../Colors';
import { Shadows } from '../Standards';

export default {
    styles: (_, props) => ({
        root: {
            boxShadow: props.variant !== 'subtle' ? Shadows.sm : '',
            fontWeight: 450,
            ...(props.variant === 'default' && {
                color: Colors.text,
            }),
        },
    }),
};
